import * as React from "react";
const SvgNumberSpinnerUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 4, viewBox: "0 0 7 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.5 0L7 4H0L3.5 0Z", fill: "currentColor" }));
export { SvgNumberSpinnerUp as ReactComponent };
